import ReportDeepDiveWithoutInsights from './reportDeepDiveNewV2WithoutInsights'
export default ReportDeepDiveWithoutInsights
